import { S2CellId } from 'nodes2ts'

/** @ignore Incorrectly eliminates sub cells in an collection of cell tokens */
export const s2Reducer = (a: string[], c: string, i: number, arr: string[]) => {
  const parentIdx = arr.findIndex((x) => c.includes(x) && x.length < c.length)
  if (parentIdx === -1) {
    if (!a.includes(c)) {
      a.push(c)
    }
  }
  return a
}

/** for where strings are to be used as begins_with predicate values for dsk indexed geo objects, these substrings are not valid parent tokens! */
export const getIndexSubtrings = (tokens: string[], maxLength: number) => {
  const substrings: string[] = []
  tokens.reduce((a, c) => {
    const substring = c.substring(0, maxLength)
    if (!a.includes(substring)) {
      a.push(substring)
    }
    return a
  }, substrings)

  return substrings
}

export type GetChildS2CellIdsInput = {
  s2CellId: S2CellId
  childLevel: number
}

/** returns all sub cellsId of input s2CellId given child level. throws error is s2CellId level is greated than child level  */
export const getS2SubCellIds = ({ s2CellId, childLevel }: GetChildS2CellIdsInput) => {
  const parentLevel = s2CellId.level()
  if (childLevel < parentLevel) {
    childLevel = parentLevel
  }
  const firstChild: S2CellId = s2CellId.childBeginL(childLevel)
  const lastChild: S2CellId = s2CellId.childEndL(childLevel)
  const allChildren: S2CellId[] = []
  for (let c: S2CellId = firstChild; !c.equals(lastChild); c = c.next()) {
    allChildren.push(c)
  }
  return allChildren
}

type GetDSKBeginsWithSubstringInput = {
  /** a collection of S2CellId of arbitrary level, maximum (smallest cell) P  */
  s2CellIds: S2CellId[]
  /** the level at which to calculate all the child cells,
   *  the defaultLevel from @iotv/config is 20 which is approx 10m squarish in medium latitudes
   * the used level for locating a point is 22, which is approx 2m squarish
   */
  childLevel: number
  /**
     * For dsk substring searches use a substring of less length than the approximate area in the linked table  ( which may not be valid tokens ) https://s2geometry.io/resources/s2cell_statistics.
     * 6 - 14 appears to be a sensible outer range for cellIds covering searchable areas
     * the length of a token for level N appears to be - perhaps - ( ( (N +  1) rounded down to nearest even number) + 2 ) divided by two
     * for substring searching, 
     *  Eg array of cell levels plus length of token 
      [ 0, 1 ],   [ 1, 2 ],   [ 2, 2 ],
      [ 3, 3 ],   [ 4, 3 ],   [ 5, 4 ],
      [ 6, 4 ],   [ 7, 5 ],   [ 8, 5 ],
      [ 9, 6 ],   [ 10, 6 ],  [ 11, 7 ],
      [ 12, 7 ],  [ 13, 8 ],  [ 14, 8 ],
      [ 15, 9 ],  [ 16, 9 ],  [ 17, 10 ],
      [ 18, 10 ], [ 19, 11 ], [ 20, 11 ],
      [ 21, 12 ], [ 22, 12 ], [ 23, 13 ],
      [ 24, 13 ], [ 25, 14 ], [ 26, 14 ],
      [ 27, 15 ], [ 28, 15 ], [ 29, 16 ],
      [ 30, 16 ]
      from test/geo/S2/s2ChildCells.test.ts

     * a working default MAY be that the maxSubstringLength is the same as token length of the largest ( lowest level ) cellId in the array
     */

  maxSubstringLength: number
}
export const getDSKBeginsWithSubstring = ({ s2CellIds, childLevel, maxSubstringLength }: GetDSKBeginsWithSubstringInput): string[] => {
  const levelNChidren = s2CellIds.map((s2CellId) => getS2SubCellIds({ s2CellId, childLevel })).flat()
  const tokens = levelNChidren.map((c) => c.toToken())

  return getIndexSubtrings(tokens, maxSubstringLength)
}

/**
 * wrapped for getDSKBeginsWithSubstring, using length of largest cell token as maxSubstringlength
 */
export const getDSKBeginsWithSubstringUsingLargestCellTokenLength = ({
  s2CellIds,
  childLevel,
}: Omit<GetDSKBeginsWithSubstringInput, 'maxSubstringLength'>): string[] => {
  const lowestS3CellTokenLength = s2CellIds.reduce((a, s2CellId) => {
    const l = s2CellId.toToken().length
    if (l < a) {
      a = l
    }
    return a
  }, 16)

  const maxSubstringLength = lowestS3CellTokenLength

  return getDSKBeginsWithSubstring({ s2CellIds, childLevel, maxSubstringLength })
}
